export const API_URL =
  process.env.REACT_APP_ENV_API_URL || 'http://localhost:8000';

export const types = {
  changeLanguage: '[Lang] Change',
  signIn: '[API] SignIn',
  signOut: '[API] SignOut',
  userCreate: '[API] Create user',
  userList: '[API] User List',
  userUpdate: '[API] Update user',
  deleteUser: '[API] Delete user',
  roles: '[API] Roles',
  createdForm: '[API] createForm',
  acceptForm: '[API] acceptForm',
  setForms: '[API] setForms',
  createProvider: '[API] create Provider',
  getProvider: '[API] get Providers',
  deleteProvider: '[API] delete Provider',
  changeFormState: '[API] change Form State',
  getCategories: '[API] get Categories',
  createCategory: '[API] create category',
  createCategoryType: '[API] create category type',
  createQuotation: '[API] create Quotation',
  updateQuotation: '[API] update Quotation',
  getQuotation: '[API] get Quotation',
  createOffer: '[API] create Offer',
  updateOffer: '[API] update Offer',
  getOffer: '[API] get Offer',
  getItem: '[API] get Item',
  validItem: '[API] valid Item',
  cmGetClients: '[API][CLIENT_MODULE] get clients',
  cmGetClientById: '[API][CLIENT_MODULE] get client by Id',
  cmCreateClient: '[API][CLIENT_MODULE] create client',
  cmUpdateClient: '[API][CLIENT_MODULE] update client',
  cmDeleteClientById: '[API][CLIENT_MODULE] delete client by Id',
  cmDownloadClients: '[API][CLIENT_MODULE] download clients',
  cmGetClientLeads: '[API][CLIENT_MODULE] get client leads',
  cmGetClientOffers: '[API][CLIENT_MODULE] get client offers',
  cmGetClientQuotations: '[API][CLIENT_MODULE] get client quotations',
  cmGetColors: '[API][COLOR_MODULE] get colors',
  cmCreateColor: '[API][COLOR_MODULE] create color',
  cmUpdateColor: '[API][COLOR_MODULE] update color',
  cmDeleteColorById: '[API][COLOR_MODULE] delete color by Id',
  cmGetComments: '[API][COMMENT_MODULE] get comments',
  cmCreateComment: '[API][COMMENT_MODULE] create comment',
  cmUpdateComment: '[API][COMMENT_MODULE] update comment',
  cmDeleteCommentById: '[API][COMMENT_MODULE] delete comment by Id',
  bmGetBrands: '[API][BRAND_MODULE] get brands',
  bmCreateBrand: '[API][BRAND_MODULE] create brand',
  bmUpdateBrand: '[API][BRAND_MODULE] update brand',
  bmDeleteBrandById: '[API][BRAND_MODULE] delete brand by Id',
  bmGetModels: '[API][BRAND_MODULE] get models',
  bmCreateModel: '[API][BRAND_MODULE] create model',
  bmUpdateModel: '[API][BRAND_MODULE] update model',
  bmDeleteModelById: '[API][BRAND_MODULE] delete model by Id',
  bmGetVersions: '[API][BRAND_MODULE] get versions',
  bmCreateVersion: '[API][BRAND_MODULE] create version',
  bmUpdateVersion: '[API][BRAND_MODULE] update version',
  bmDeleteVersionById: '[API][BRAND_MODULE] delete version by Id',
  lmGetLeads: '[API][LEAD_MODULE] get leads',
  lmGetLeadItems: '[API][LEAD_MODULE] get lead items',
  lmCreateLead: '[API][LEAD_MODULE] create lead',
  lmGetLeadUsers: '[API][LEAD_MODULE] get lead users',
  lmUpdateLead: '[API][LEAD_MODULE] update lead',
  lmUpdateLeadOrder: '[API][LEAD_MODULE] update lead order',
  lmGetLeadById: '[API][LEAD_MODULE] get lead by id',
  clientList: '[API]client list', // TODO: Check if this is needed
  createClient: '[API] create client', // TODO: Check if this is needed
  updateClient: '[API] update client', // TODO: Check if this is needed
  notify: '[API] Notify clients', // TODO: Check if this is needed
  changeImageStateForm: '[API] chgane state image',
  formFile: '[API] save file item',
  webPageForm: '[API] show in WebPage',
  formPhoto: '[API] upload Photo',
  getStats: '[API] get stats',
  createReport: '[API] create reports',
  feature: '[API] feature',
  getItemStorage: '[API] item storages',
  selectFirst: '[API] first image item',
  exportQuotation: '[API] export Quotation',
  exportOffer: '[API] export Offer',
  bnrGetBanners: '[API][BANNER_MODULE] get banners',
  bnrCreateBanner: '[API][BANNER_MODULE] create banner',
  bnrUpdateBanner: '[API][BANNER_MODULE] update banner',
  bnrDeleteBannerById: '[API][BANNER_MODULE] delete banner by Id',
  faqGetFAQs: '[API][FAQ_MODULE] get FAQs',
  faqCreateFAQ: '[API][FAQ_MODULE] create FAQ',
  faqUpdateFAQ: '[API][FAQ_MODULE] update FAQ',
  faqDeleteFAQById: '[API][FAQ_MODULE] delete FAQ by Id',
  svcGetServices: '[API][SERVICE_MODULE] get services',
  svcCreateService: '[API][SERVICE_MODULE] create service',
  svcUpdateService: '[API][SERVICE_MODULE] update service',
  svcDeleteServiceById: '[API][SERVICE_MODULE] delete service by Id',
  blgGetBlogs: '[API][BLOG_MODULE] get blogs',
  blgCreateBlog: '[API][BLOG_MODULE] create blog',
  blgUpdateBlog: '[API][BLOG_MODULE] update blog',
  blgDeleteBlogById: '[API][BLOG_MODULE] delete blog by Id',
  smGetSalesByProvider: '[API][SALES_MODULE] get sales by provider',
  smGetSalesBySeller: '[API][SALES_MODULE] get sales by seller',
  rpGetDashboard: '[API][REPORT_MODULE] get dashboard',
  roleCreate: '[API][ROLE_MODULE] create role',
  roleUpdate: '[API][ROLE_MODULE] update role',
  roleDelete: '[API][ROLE_MODULE] delete role',
  permissionRegistry: '[API][PERMISSION] get registry',
};
